import { render, staticRenderFns } from "./weightageModification.vue?vue&type=template&id=5a3589a0"
import script from "./weightageModification.vue?vue&type=script&lang=js"
export * from "./weightageModification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports